module.exports = __webpack_public_path__ + "static/img/00index1_16.7546230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/00index1_16.jpg
// module id = k28F
// module chunks = 0